const EVENT_NAME = 'persistent-report-confirmation'

let confirmationPending = false

/**
 * Solicita una única confirmación global antes de mandar un reporte a la cola.
 * Centralizarlo en el interceptor también cubre nuevos listados que adopten
 * `queue.persistentReport`, sin depender de que cada vista lo implemente.
 */
export const confirmPersistentReportSubmission = () => {
  if (confirmationPending) return Promise.resolve(false)

  confirmationPending = true
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, {
      detail: {
        resolve: (confirmed) => {
          confirmationPending = false
          resolve(Boolean(confirmed))
        },
      },
    }))
  })
}

export const PERSISTENT_REPORT_CONFIRMATION_EVENT = EVENT_NAME
